const reviews = [
  {
    initials: "CJ",
    name: "陳建國",
    role: "總經理",
    company: "鮮果連鎖超市",
    country: "中國",
    quote:
      "合作兩年多了,Farmer's Basket 的火龍果和芒果品質一直很穩定,客戶反饋非常好。他們的冷鏈物流做得很專業,水果到貨時新鮮度保持得很好。",
  },
  {
    initials: "YT",
    name: "山田太郎",
    role: "採購主管",
    company: "東京水果批發市場",
    country: "日本",
    quote:
      "品質管理非常嚴格,每批貨都能達到我們的標準。特別欣賞他們的服務態度,溝通順暢,問題解決及時。",
  },
  {
    initials: "KS",
    name: "金秀英",
    role: "進口部經理",
    company: "首爾農產品貿易公司",
    country: "韓國",
    quote:
      "越南水果在韓國市場很受歡迎,Farmer's Basket 提供的產品種類豐富,價格合理,是我們長期合作的優質供應商。",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-orange-100 text-orange-700 text-sm font-medium rounded-full mb-4">
            <i className="ri-star-fill"></i>
            <span>客戶見證</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-orange-700">他們信任我們</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {reviews.map((r, i) => (
            <div key={i} className="bg-blue-50 rounded-2xl p-8 space-y-6 hover:shadow-lg transition-shadow">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-orange-700 rounded-full flex items-center justify-center text-white font-semibold">
                  {r.initials}
                </div>
                <div>
                  <div className="font-semibold text-gray-900">{r.name}</div>
                  <div className="text-sm text-gray-600">{r.role}</div>
                  <div className="text-xs text-gray-500">{r.company}</div>
                </div>
              </div>
              <div className="flex space-x-1 text-yellow-500">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed text-sm">&ldquo;{r.quote}&rdquo;</p>
              <div className="flex items-center text-sm text-gray-500">
                <i className="ri-map-pin-line mr-1"></i>
                {r.country}
              </div>
            </div>
          ))}
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="relative rounded-2xl overflow-hidden shadow-lg h-80">
            <img
              alt="包裝工廠"
              className="w-full h-full object-cover object-top"
              src="https://public.readdy.ai/ai/img_res/fb5afa069bf5da40dba13f96df53540a.jpg"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
              <h3 className="text-2xl font-bold mb-2">現代化包裝設施</h3>
            </div>
          </div>
          <div className="space-y-6">
            <div className="bg-blue-50 rounded-2xl p-8 space-y-4">
              <div className="flex space-x-1 text-yellow-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed">
                &ldquo;Excellent quality tropical fruits with consistent supply. Their export documentation is always
                complete and accurate, making customs clearance smooth.&rdquo;
              </p>
              <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-orange-700 rounded-full flex items-center justify-center text-white font-semibold text-sm">
                    MC
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900 text-sm">Michael Chen</div>
                    <div className="text-xs text-gray-600">Procurement Director</div>
                  </div>
                </div>
                <div className="text-xs text-gray-500">美國</div>
              </div>
            </div>
            <div className="bg-blue-50 rounded-2xl p-8 space-y-4">
              <div className="flex space-x-1 text-yellow-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed">
                &ldquo;專業的團隊,完善的服務。從訂單確認到貨物交付,每個環節都很順利。榴槤和山竹的品質特別好,市場反應很熱烈。&rdquo;
              </p>
              <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-orange-700 rounded-full flex items-center justify-center text-white font-semibold text-sm">
                    LW
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900 text-sm">李文華</div>
                    <div className="text-xs text-gray-600">營運總監</div>
                  </div>
                </div>
                <div className="text-xs text-gray-500">新加坡</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
